module.exports = __webpack_public_path__ + "img/white-logo-cn-express.2390244.webp";